module.exports = __webpack_public_path__ + "img/circleAlfa.f3915439.svg";